import { get, post, put, del } from './_httpClient';

export async function getPATPeers() {
  return get(`/clp/evaluations-pat/peers`);
}

export async function postPATEvaluation({ id, payload }) {
  return post(`/clp/evaluations-pat/peers/${id}`, payload);
}

export async function getFinalEvaluations() {
  const { status, message, data } = await get(`/clp/evaluations-final/me`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getMyCertificateData() {
  const { status, message, data } = await get(`/clp/evaluations-final/certificate/me`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function confirmMyCertificate() {
  const { status, message, data } = await post(`/clp/evaluations-final/certificate/me/confirm`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getPendingCertificates({ batchId }) {
  const { status, message, data } = await get(
    `/clp/evaluations-final/certificates/pending?batchId=${batchId}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function issueCertificateManually({ evaluationFinalId, manualNumber }) {
  const { status, message, data } = await post(
    `/clp/evaluations-final/certificates/${evaluationFinalId}/issue`,
    { manualNumber }
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function refreshFinalEvaluations({ id }) {
  const { status, message } = await post(`/clp/students/${id}/evaluations/refresh`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function generateFinalEvaluations({ id }) {
  const { status, message } = await get(`/clp/students/${id}/evaluations/generated`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function getAllEvaluations({ batchId, page, pageSize, filterBy = '' }) {
  const { status, message, data } = await get(
    `/clp/students/evaluations?batchId=${batchId}&pageSize=${pageSize}&page=${page}&filterBy=${filterBy}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getMentorEvaluations({ batchId, page, pageSize }) {
  const { status, message, data } = await get(
    `/clp/mentors/evaluations?batchId=${batchId}&pageSize=${pageSize}&page=${page}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getEvaluationsById({ id }) {
  const { status, message, data } = await get(`/clp/students/${id}/evaluations`);
  if (status !== 'success') {
    return { status, message, data: null };
  }
  return { status, message: null, data };
}

export async function getPATEvaluationsReceivedById({ id }) {
  const { status, message, data } = await get(`/clp/evaluations-pat/received/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getPATEvaluationsGivenById({ id }) {
  const { status, message, data } = await get(`/clp/evaluations-pat/given/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function deletePATEvaluationById({ id, payload }) {
  const { status, message } = await del(`/clp/evaluations-pat/${id}`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

// Beda dari assignStudentsEvaluation/deleteStudentsEvaluation (mentor
// meng-klaim dirinya sendiri) -- ini admin memilihkan/melepas mentor mana
// pun untuk seorang mahasiswa, dipakai a.l. saat admin memutuskan mengganti
// mentor setelah divisi penempatan mahasiswa berubah.
export async function adminChangeStudentMentor({ id, mentorsId }) {
  const { status, message } = await put(`/clp/evaluations-final/students/${id}/mentor`, {
    mentorsId,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function resetMentorsEvaluations({ id, classificationsType }) {
  const { status, message } = await put(
    `/clp/evaluations-final/students/${id}/reset?classifications=${classificationsType}`,
    {}
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

// NOT USED!
export async function addAdminEvaluation({ id, payload }) {
  const { status, message } = await post(`/clp/admin/students/evaluationss/${id}/evaluates`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function putAdminPATEvaluation({ id, score }) {
  const { status, message } = await put(`/clp/evaluations-pat/admin/${id}`, { score });
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function updateEvaluation({ id, payload }) {
  const { status, message } = await put(`/clp/evaluations-final/students/${id}/bcf`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function updateEvaluationNote({ finalEvaluationNote, id }) {
  const { status, message } = await put(`/clp/evaluations-final/students/${id}/note`, {
    finalEvaluationNote,
  });
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function getFinalHardSkillEvaluations({ id }) {
  const { status, message, data } = await get(`/clp/evaluations-final/students/${id}/hard-skill`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateFinalHardSkillEvaluations({ id, payload }) {
  const { status, message } = await put(`/clp/evaluations-final/students/${id}/hard-skill`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function getFinalSoftSkillEvaluations({ id }) {
  const { status, message, data } = await get(`/clp/evaluations-final/students/${id}/soft-skill`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateFinalSoftSkillEvaluations({ id, payload }) {
  const { status, message } = await put(`/clp/evaluations-final/students/${id}/soft-skill`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function addSoftSkillEvaluation({ id, payload }) {
  const { status, message } = await post(
    `/clp/mentors/evaluations/${id}/evaluates/softskill`,
    payload
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function addHardSkillEvaluation({ id, payload }) {
  const { status, message } = await post(
    `/clp/mentors/evaluations/${id}/evaluates/hardskill`,
    payload
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function addMentorEvaluation({ id, payload }) {
  const { status, message } = await post(`/clp/mentors/evaluations/${id}/evaluates`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function deleteStudentsEvaluation({ id }) {
  return del(`/clp/students/${id}/mentor`);
}

export async function assignStudentsEvaluation({ id }) {
  return put(`/clp/students/${id}/mentor`, {});
}
